export default __webpack_public_path__ + "static/media/Credit & Landing-12.16786f4d.svg";